import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout';
import OrderCard from '../../components/orderCard';
import { withRouter } from 'react-router-dom';
import './styles.scss';
import { withAlert } from 'react-alert';
import { LIQUOR_BRAND_TYPE, STORAGE_KEYS } from '../../helpers/constants';
import { checkOrderValidityForRole } from './roleMapping.service';
import { ENUM_LAYOUT_STATE, ENUM_PAGES, ENUM_STATUS } from '../../helpers/enums';
import useLayoutContext from '../../contexts/layout.context';
import { filterOrdersByRole } from '../../helpers/functions';
import { statusIsStarted } from '../../helpers/permissions.service';

const Dispatch = () => {
  const {
    setSocketConfig,
    orders,
    loading,
    filters,
    onFilterClick,
    searchValue,
    setSearchValue,
    prefilteredOrders: filteredOrders,
    roleIsLiquorKitchenAdmin
  } = useLayoutContext();

  const [orderSummary, setOrderSummary] = useState({
    pendingOrdersCount: 0,
    trackingOrdersCount: 0
  });
  const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN);

  const getRoomName = () => {
    if (cokitchenId) {
      return `order-update-cokitchen:${cokitchenId}`;
    }
    return 'order-update';
  };

  const initPage = async () => {
    setSocketConfig({ roomName: getRoomName(), page: ENUM_PAGES.DISPATCH });
    return () => {
      setSocketConfig({ roomName: '', page: null });
    };
  };

  useEffect(async () => {
    initPage();
  }, []);

  useEffect(() => {
    setOrderSummary({
      pendingOrdersCount: orders.filter((order) => !order.kitchen_accepted).length,
      trackingOrdersCount: orders.filter((order) => order.kitchen_accepted).length
    });
  }, [orders]);

  const ordersFilteredByBrand = filteredOrders?.filter((order) => {
    const brandTypeIsLiquor = order?.calculated_order?.brand_ids?.some(
      (brand) => brand?.brand_type === LIQUOR_BRAND_TYPE
    );
    return filterOrdersByRole(brandTypeIsLiquor, roleIsLiquorKitchenAdmin);
  });

  const getLayoutState = () => {
    if (ordersFilteredByBrand.length === 0 && searchValue) return ENUM_LAYOUT_STATE.EMPTY_SEARCH;
    if (
      (ordersFilteredByBrand?.length === 0 ||
        (orderSummary?.trackingOrdersCount === 0 && orderSummary?.pendingOrdersCount === 0)) &&
      !loading
    ) {
      return ENUM_LAYOUT_STATE.WAITING;
    }
    if (loading) return ENUM_LAYOUT_STATE.LOADING;
    return ENUM_LAYOUT_STATE.PAGE;
  };
  return (
    <Layout
      pendingOrders={orderSummary.pendingOrdersCount}
      trackingOrders={orderSummary.trackingOrdersCount}
      searchValue={searchValue}
      searchChange={(e) => setSearchValue(e.target.value?.toUpperCase())}
      layoutState={getLayoutState()}
      filters={filters}
      onFilterClick={onFilterClick}>
      {ordersFilteredByBrand.map((item) => (
        <OrderCard
          key={item.id + item.updated_at}
          defaultStatus={ENUM_STATUS.DISPATCH}
          actionDisabled={statusIsStarted(item.status)}
          order={item}
          checkOrderValidityForRole={checkOrderValidityForRole}
        />
      ))}
    </Layout>
  );
};
export default withRouter(withAlert()(Dispatch));
